import { Field, InjectedFormProps, reduxForm } from 'redux-form';

import ConnectedTagSelectField from 'dashboard/components/FormControls/ConnectedTagSelectField';
import Form from 'dashboard/layouts/FormLayout/Form';
import { TagScope } from 'dashboard/models/tag';
import Button from 'design-system/components/Button';
import { HStack } from 'design-system/components/Stack';

interface FormUpdateTagsProps {
  tagScope: TagScope;
  handleCancel: () => void;
}

const FormUpdateTags = ({
  pristine,
  submitting,
  tagScope,
  handleCancel,
  handleSubmit,
}: FormUpdateTagsProps & InjectedFormProps<FormUpdateTagsData, FormUpdateTagsProps>) => {
  return (
    <Form onSubmit={handleSubmit}>
      <Field
        label='Tags'
        component={ConnectedTagSelectField}
        id='form-update-tags__tags-select'
        name='tags'
        placeholder='Select a tag'
        disabled={submitting}
        tagScope={tagScope}
      />

      <HStack equal={true}>
        <Button
          variant='basic'
          id='form-update-tags__cancel'
          disabled={submitting}
          onClick={handleCancel}
        >
          Cancel
        </Button>
        <Button
          type='submit'
          data-test='form-update-tags__submit'
          disabled={submitting || pristine}
          isPending={submitting}
        >
          Update
        </Button>
      </HStack>
    </Form>
  );
};

export interface FormUpdateTagsData {
  tags: string[];
}

export default reduxForm<FormUpdateTagsData, FormUpdateTagsProps>({
  form: 'updateTags',
  // these updates the form's initial state when you save so the next time you open the modal the values are correct
  enableReinitialize: true,
  keepDirtyOnReinitialize: true,
})(FormUpdateTags);
